module.exports = __webpack_public_path__ + "static/facebook-logo-93fb2ee96b390846a1c8e47bf6541e9b.png";